'use client';
import { useState, useEffect } from 'react';
 

export default function Header() {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/90 backdrop-blur-xl border-b border-black/[0.07] shadow-sm py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2.5 group">
          <img
            src="/assets/images/8f3a7779-7682-426a-9bc9-93d18d0c2628_removalai_preview-1774537813991.png"
            alt="ElevateX"
            style={{
              height: '36px',
              width: 'auto',
              filter: scrolled ? 'none' : 'brightness(0) invert(1)',
              transition: 'filter 0.3s ease',
            }}
            className="transition-transform duration-300 group-hover:scale-105"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {[
            { label: 'How It Works', href: '#features' },
            { label: 'The Flow', href: '#how-it-works' },
            { label: 'Installation', href: '#installation' },
            { label: 'FAQ', href: '#faq' },
          ]?.map((item) => (
            <a
              key={item?.label}
              href={item?.href}
              className={`text-sm font-600 transition-colors duration-200 ${
                scrolled ? 'text-foreground hover:text-primary' : 'text-white/90 hover:text-white'
              }`}
              style={{ fontWeight: 600 }}
            >
              {item?.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="#waitlist"
            className="btn-primary text-sm px-5 py-2.5 inline-block"
            style={{ fontWeight: 700 }}
          >
            Book Your Strategy Call →
          </a>
        </div>

        {/* Mobile menu toggle */}
        <button
          suppressHydrationWarning
          className={`md:hidden p-2 rounded-lg transition-colors ${
            scrolled ? 'text-foreground' : 'text-white'
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
            {menuOpen ? (
              <path d="M3 3L19 19M3 19L19 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            ) : (
              <>
                <path d="M3 6H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <path d="M3 11H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <path d="M3 16H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              </>
            )}
          </svg>
        </button>
      </div>
      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-black/[0.07] px-5 py-4 space-y-3">
          {[
            { label: 'How It Works', href: '#features' },
            { label: 'The Flow', href: '#how-it-works' },
            { label: 'Installation', href: '#installation' },
            { label: 'FAQ', href: '#faq' },
          ]?.map((item) => (
            <a
              key={item?.label}
              href={item?.href}
              className="block text-sm font-600 text-foreground hover:text-primary transition-colors"
              style={{ fontWeight: 600 }}
              onClick={() => setMenuOpen(false)}
            >
              {item?.label}
            </a>
          ))}
          <a
            href="#waitlist"
            className="btn-primary text-sm px-5 py-2.5 inline-block w-full text-center"
            style={{ fontWeight: 700 }}
            onClick={() => setMenuOpen(false)}
          >
            Book Your Strategy Call →
          </a>
        </div>
      )}
    </header>
  )
}